import { Component, Input } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-riskscores-column-renderer',
  styles: [
    `
      .risk-score {
        display: inline-block;
        padding: 1px 12px;
        border-radius: 10px;
        font-weight: bold;
        color: #111;
      }
      .medh {
        background-color: LightSalmon;
      }
      .proe {
        background-color: LightPink;
      }
      .epis {
        background-color: PaleGoldenrod;
      }
      .pall {
        background-color: Bisque;
      }
      .dail {
        background-color: SkyBlue;
      }
      .conl {
        background-color: Plum;
      }
      .acui {
        background-color: LightGreen;
      }
      .compl {
        background-color: GoldenRod;
      }
    `
  ],
  template: `
    <span *ngIf="medicalHistory !== null" class="risk-score medh" title="ADLs">{{
      medicalHistory
    }}</span>
    <span *ngIf="programEligibility !== null" class="risk-score proe" title="Program Eligibility">{{
      programEligibility
    }}</span>
    <span *ngIf="episodeSummary !== null" class="risk-score epis" title="Comorbidities">{{
      episodeSummary
    }}</span>
    <span
      *ngIf="palliativeScreening !== null"
      class="risk-score pall"
      title="Palliative Screening"
      >{{ palliativeScreening }}</span
    >
    <span *ngIf="dailyQMAXN !== null" class="risk-score dail" title="Daily QM AXN">{{
      dailyQMAXN
    }}</span>
    <span *ngIf="contactLevel !== null" class="risk-score conl" title="Risk Summary">{{
      contactLevel
    }}</span>
    <span *ngIf="acuityScale !== null" class="risk-score acui" title="Acuity Scale">{{
      acuityScale
    }}</span>
    <span *ngIf="complexity !== null" class="risk-score compl" title="Complexity">{{
      complexity
    }}</span>
  `,
  standalone: false
})
export class RiskScoresColumnRendererComponent implements AgRendererComponent {
  private params: any

  @Input() canEdit = true
  @Input() canDelete = true

  contactLevel: number = null
  episodeSummary: number = null
  medicalHistory: number = null
  mentalHealth: number = null
  phaseEvent: number = null
  palliativeScreening: number = null
  dailyQMAXN: number = null
  programEligibility: number = null
  acuityScale: number = null
  complexity: number = null

  agInit(params: any): void {
    this.params = params

    this.contactLevel = this.params.data.ContactLevelRiskScore
    this.episodeSummary = this.params.data.EpisodeSummaryRiskScore
    this.medicalHistory = this.params.data.MedicalHistoryRiskScore
    this.palliativeScreening = this.params.data.PalliativeScreeningRiskScore
    this.dailyQMAXN = this.params.data.DailyQMAXNRiskScore
    this.programEligibility = this.params.data.ProgramEligibilityRiskScore
    this.acuityScale = this.params.data.AcuityScaleRiskScore
    this.complexity = this.params.data.ComplexityRiskScore
  }

  refresh(params: any): boolean {
    return false
  }
}
